import { useI18n } from "vue-i18n";
import { countryNames } from "../utils/addressCountry";
import { detectCountryFormat, formatAddress, formatAddressParts, } from "../utils/formatAddress";
export function useAddressFormatter() {
    const { t } = useI18n();
    const names = countryNames(t);
    const parts = (address) => formatAddressParts(address, detectCountryFormat(address.country, address.region), names);
    return {
        format: (address) => formatAddress(address, detectCountryFormat(address.country, address.region), names),
        parts,
        names,
    };
}
